import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { Formik } from "formik";
import { Captcha } from "primereact/captcha";
import React from "react";
import { AuthContext } from "../App";
import { loginUser } from "../services/LoginService";
import { Loading } from "./Loading";
import { ShowMessageBox } from "./ShowMessageBox";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"Copyright © "}
            <Link color="inherit" href="http://www.ebco.com.br">
                {new Date().getFullYear()} Copyright @ Ebco Systems Ltda. Todos os
                direitos reservados
            </Link>
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

let msg = "";
let severity = "error";

function Login() {
    const classes = useStyles();
    const { dispatch } = React.useContext(AuthContext);
    const [openSnackBar, setOpenSnackBar] = React.useState(false);
    const [openLoading, setOpenLoading] = React.useState(false);

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />

            <Loading open={openLoading} />

            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Conexão ao sistema
                </Typography>

                <ShowMessageBox
                    open={openSnackBar}
                    setOpen={setOpenSnackBar}
                    severity={severity}
                    msg={msg}
                />

                <Formik
                    initialValues={{ username: "", password: "", recaptcha: "", msg: "" }}
                    validate={(values) => {
                        const errors = {};
                        if (!values.username) {
                            errors.username = "Obrigatório";
                        } else if (
                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.username)
                        ) {
                            errors.username = "E-mail invalido";
                        } else if (!values.password) {
                            errors.password = "Obrigatório";
                        } else if (values.password.length < 5) {
                            errors.password = "Numero de caracteres invalidos para senha";
                        } else if (!values.recaptcha) {
                            errors.recaptcha = "Não sou robo";
                        }
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, props }) => {
                        setSubmitting(true);
                        setOpenLoading(true);
                        const auth = {
                            username: values.username,
                            password: values.password,
                            version_web: process.env.REACT_APP_VERSION,
                        };
                        try {
                            const resJson = await loginUser(auth);
                            dispatch({ type: "LOGIN", payload: resJson.data });
                            setSubmitting(false);
                            setOpenLoading(false);
                        } catch (error) {
                            switch (error.message) {
                                case "Request failed with status code 401":
                                    console.log("Error");
                                    msg = "Erro de autenticacao";
                                    console.log(msg);
                                    setOpenSnackBar(true);
                                    break;
                                case "Request failed with status code 403":
                                    console.log("Error");
                                    msg = "Aplicação do cliente desatualiza";
                                    console.log(msg);
                                    setOpenSnackBar(true);
                                    break;
                                default:
                                    console.log("Error");
                                    msg = error.message;
                                    console.log(msg);
                                    setOpenSnackBar(true);
                            }
                            setOpenLoading(false);
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <TextField
                                value={values.username}
                                name="username"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="username"
                                autoComplete="false"
                                type="text"
                                label="E-Mail"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                helperText={errors.username}
                                autoFocus
                            />

                            <TextField
                                type="password"
                                name="password"
                                id="password"
                                fullWidth
                                label="Senha"
                                variant="outlined"
                                margin="normal"
                                value={values.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                helperText={errors.password}
                            />

                            <Button
                                variant="outlined"
                                color="primary"
                                fullWidth
                                type="submit"
                                disabled={!isValid}
                                className={classes.submit}
                            >
                                Autenticar
                            </Button>
                            <Grid container>
                                <Grid item xs>
                                    <Captcha
                                        siteKey="6LcFeh0bAAAAAJl80I_ldJXz418gbnu9hYWspDm0"
                                        language="pt"
                                        onResponse={(response) => {
                                            setFieldValue("recaptcha", response);
                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    <Link href="/esquecisenha" variant="body2">
                                        Esqueci minha senha?
                                    </Link>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
        </Container>
    );
}

export default Login;
